/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable default-case */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */

import { UI_FriendshipChest } from '../Elements/Windows/FriendshipChest/UI_FriendshipChest';
import OMT_UI_CrossPromoMapButton from '../OMT_UI/Buttons/OMT_UI_CrossPromoMapButton';
import { FadeLayer } from '../Elements/FadeLayer';
import { XPROMO_PLACEMENTS } from '../Services/OMT/OMT_CrossPromo';
import WorldMap from '../Elements/WorldMap/WorldMap';
import { Friendship_Chest } from '../Elements/Windows/FriendshipChest/Friendship_Chest';
import { GENERIC_WINDOW_STYLE } from '../Elements/Windows/Window_Generic';
import OMT_BgLoadingUtil from '../Utils/OMT_BgLoadingUtil';
import { UI_EventPostcard } from '../Elements/Windows/eventPostcard/UI_EventPostcard';
import StartBoosterConfig from '../Elements/StartBoosterConfig';
import UIFxLayer from '../Elements/GameState/UI/Layers/UIFxLayer';

G.World = function(game) {
    //
};

var s = s || null;

G.World.prototype = {

    init: function(lastLevelData, onCreateCallback) {

        G.dailyMissionsMgr.dayCheck();

        s = game.state.getCurrentState();
        this.lastLevelData = lastLevelData;
        this._onCreateCallback = onCreateCallback;

        this.startBoosterConfig = new StartBoosterConfig();

        OMT.feature.checkFeatureRequestHelp();
        OMT.feature.checkFeatureRequestMoveHelp();

        // moved body added background styles to stylesheet.css
        document.body.classList.add('initialized');

        OMT.platformTracking.logFTUEvent('FTUSagaMapVisible', 'RTUSagaMapVisible');
        OMT.platformTracking.logFTUEvent('FTUX_SagaMapVis', null);

        // send any previous incomplete level rewards
        DDNA.transactionHelper.sendQueuedLevelCoinRewards();
    },

    create: function() {
        var self = this;

        game.resizeGame();

        // need to bypass world startup in restore progress
        if (OMT.envData.isRestoreProgressPayload && !G.saveState.progressWasRestored) {
            G.fadeLayer = new FadeLayer();
            this._initFlow();
            return;
        }

        this.map = new WorldMap(
            G.json.settings.mapTiles,
            G.json.settings.mapAnimatedElements,
            null,
            false,
            function(visibilityState) {
                if (visibilityState === G.WorldMapPlayerAvatar.VisibilityStates.Visible) {
                    self._hideQuickPanButton();
                } else {
                    self._showQuickPanButton(visibilityState);
                }
            }
        );
        this.map.signals.onGateOpen.add(this._openGate, this);

        this._iconGroup = new Phaser.Group(game);
        this._organizeWorldSideButtons();

        new G.UI_OptInIcon(200, 670);

        this.windowMgr = new G.WindowMgr(0, 0);
        this.windowMgr.offsetV = G.WindowMgr.Constants.WorldVerticalOffset;
        this.windowMgr.resize();

        this._addQuickPanButton();

        //var highscorePanel = new G.HighscorePanel2(game, this._rewardCoins.bind(this));

        //G.sb('openLifeTransactionsMenu').add(function () { highscorePanel.expandLivesList(); });

        this.windowMgr.addLayerToWorld(G.WindowMgr.LayerNames.BelowHeaderPanel);
        this.panel = new G.UI_MapPanel(this.windowMgr);
        this.windowMgr.addLayerToWorld(G.WindowMgr.LayerNames.Base);
        this.uiTargetParticlesBW = new G.UITargetParticles();

        new G.FxMapLayer();

        //this.TEST_ES6 = new (require('../Elements/TEST_ES6.jsx'))(0,0);

        if (!(OMT.feature.getFeatureRequestHelp() || (OMT.feature.getFeatureFriendshipChest() && !OMT.feature.getFeatureFriendshipChestActiveByLevel())) && G.PRELEVEL_PER_LEVEL_LEADERBOARD) {
            //this._addLeaderboardPerLevel();
        }

        this.windowMgr.addLayerToWorld(G.WindowMgr.LayerNames.AboveHighScorePanel);
        this.windowMgr.addLayerToWorld(G.WindowMgr.LayerNames.OverlayLayer);

        this.worldSidePanel = new G.WorldSidePanel();

        // highscorePanel.signals.expanded.add(
        //   () => { this.worldSidePanel.hideReasons.add('LeaderboardExpanded'); },
        // );
        // highscorePanel.signals.minimized.add(
        //   () => { this.worldSidePanel.hideReasons.remove('LeaderboardExpanded'); },
        // );

        this.uiFxLayer = new UIFxLayer();
        this.uiTargetParticles = new G.UITargetParticles();

        G.fadeLayer = new FadeLayer();

        //OMT.payments.checkUnconsumedProducts();

        this.map.checkAndUpdateAvatarVisibilityState();

        this._initFlow();

        // set listeners and load / reload crosspromo data
        OMT.crossPromo.signals.onGetXPromo.removeAll();
        OMT.crossPromo.signals.onGetXPromo.addOnce(this._onXPromosReady.bind(this));
        OMT.crossPromo.loadCrossPromoData();

        OMT_BgLoadingUtil.startBackgroundAssetLoading();
    },

    /**
     * state shutdown event
     */
    shutdown: function() {
        OMT.crossPromo.signals.onGetXPromo.removeAll();
        G.sb('crossPromoSeen').removeAll();
        const { flowMgr } = G.WorldMapAppearFlow;
        flowMgr.cleanup();
    },

    /**
     * CrossPromo data is loaded
     */
    _onXPromosReady: function() {
        if (game.state.current !== 'World') return;
        const promoActive = OMT.crossPromo.isPlacementActive(XPROMO_PLACEMENTS.ICON_PICTURE_COMBO);
        if (promoActive) this._showCrossPromoIcon(OMT.crossPromo.getPromoByPlacementId(XPROMO_PLACEMENTS.ICON_PICTURE_COMBO));
    },

    /**
     * show CrossPromo icon
     * @param {Object} crossPromoData
     */
    _showCrossPromoIcon: function(crossPromoData) {
        if (!this.xpromoButton || !OMT.crossPromo.showCrossPromoIcon) return;
        const assetData = OMT.crossPromo.getAssetsForPromo(crossPromoData, OMT.envData.settings.env.lang, 'icon');
        if (!assetData) return;
        this.xpromoButton.init(crossPromoData, assetData.src);
        this.xpromoButton.enterButton();
    },

    update: function() {
        G.delta();
    },

    _initFlow: function() {
        // if (this.checkIE11()) { // if IE11, don't check flowMgr and Payload. Keep them untouched.
        //   return;
        // }

        var flowMgr = G.WorldMapAppearFlow.flowMgr;

        flowMgr.onPopUpReqested.add(function() {
            this.windowMgr.pushWindow.apply(this.windowMgr, arguments);
        }, this);
        flowMgr.onOpenGate.add(this._openGate, this);
        console.log(this.lastLevelData);
        flowMgr.startFlow(this.lastLevelData);
        if (OMT.envData.isRestoreProgressPayload) return; // dont continue if this is a restore progress flow

        //this._check_GBMessages();
        this._check_friendshipChest();
        if (this.lastLevelData) {

            // we want to set the coins counter to what it would have been before level reward for the batch animation
            G.sb('onCoinsChange').dispatch(G.saveState.getCoins() - this.lastLevelData.reward);

            if (OMT.feature.getUseNewFTUX()) { //Giant check to see if you just came out of the last level and the wheel just unlocked
                if (G.saveState.getLastPassedLevelNr() == G.featureUnlock.unlockLevels.dailyWheel && G.saveState.data.freeSpin && (this.lastLevelData.lvlNr + 1) == G.featureUnlock.unlockLevels.dailyWheel) {
                    this.dailySpinIcon.onClick({ showCloseButton: false });
                }
            }
            this.windowMgr.onQueueEmpty()
                .then((function() {
                    this.map.postLevelFlow(this.lastLevelData);
                }).bind(this));
        } else {
            this.map._canCheckMysteryGiftTimer = true;
        }

        if (this._onCreateCallback) {
            this._onCreateCallback();
        }
    },

    _addLeaderboardPerLevel: function() {

        this.highscorePanelPerLevel = new G.HighscorePanelIngame();

        G.sb('levelWindowOpen').add(async(lvlNr, isDailyChallenge) => {
            if (game.state.getCurrentState() !== this) return;

            this.highscorePanelPerLevel.removeCurrentLeaderboardData();
            this.highscorePanelPerLevel.makeVisible();

            try {
                if (lvlNr < 1 || lvlNr > G.json.levels.order.length) return;
                let lvlId = (G.json.levels.order[lvlNr - 1] || lvlNr).toString();
                if (isDailyChallenge) lvlId += '_challenge';
                let entriesArray = await OMT.leaderboards.getLeaderBoardEntries('default', lvlId);
                this.highscorePanelPerLevel.injectLevelData(entriesArray, null);
            } catch (error) {
                this.highscorePanelPerLevel.makeHidden();
            }
        });

        let onLevelWindowClosed = () => {
            if (this.highscorePanelPerLevel == null) return;
            this.highscorePanelPerLevel.makeHidden();
        };

        G.sb('hideHighscoreBoard').add(() => { // Hides leaderboard when requestHelp is opened. Called from Window_Level.js
            this.highscorePanelPerLevel.makeHidden();
        });

        G.sb("levelWindowClose").add(onLevelWindowClosed);
    },

    _openGate: function(gateId, showTreasureHuntWindow) {
        // imports
        var settings = G.json.settings;

        G.Helpers.gatesMgr.openGate(gateId);

        // if first gate was opened, init treasure hunt
        if (showTreasureHuntWindow) {
            const { treasureHuntMgr } = G.TreasureHunt;

            if (treasureHuntMgr.isEventReadyToStart()) {
                this.windowMgr.pushWindow('treasureHuntEvent');
            } else if (treasureHuntMgr.isEventActive()) {
                // Check if path to next treasure hunt level is clear of gates before starting the level
                const nextLevel = G.saveState.getLastPassedLevelNr() + 1;
                const nextGate = G.Helpers.gatesMgr.getFirstClosedGateData();
                const nextGateLevel = nextGate ? nextGate.lvlNr : 0;

                if (nextGateLevel > nextLevel) {
                    const lvlIndex = treasureHuntMgr.getTreasureHuntLevelIndex();
                    if (G.saveState.getLives() === 0 && G.saveState.getUnlimitedLivesSec() === 0) {
                        G.sb('pushWindow').dispatch(['notEnoughLives', {
                            openLevelPopUp: true,
                            lvlIndex: lvlIndex,
                            levelPopUpLayerName: G.WindowMgr.LayerNames.AboveHighScorePanel,
                        }], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
                    } else if (lvlIndex !== null) {
                        G.sb('pushWindow').dispatch(['level', lvlIndex]);
                    }
                    // open level
                }
            }
        }
    },

    // quick pan

    _addQuickPanButton: function() {
        var quickPanButton = new G.WorldMapQuickPanButton();
        this._quickPanButton = quickPanButton;
        quickPanButton.fixedToCamera = true;
        quickPanButton.cameraOffset.x = (game.width * 0.5);
        quickPanButton.cameraOffset.y = 170;
        G.sb('onScreenResize').add(function() {
            quickPanButton.cameraOffset.x = (game.width * 0.5);
            if (quickPanButton.direction === G.WorldMapQuickPanButton.Directions.Up) {
                quickPanButton.cameraOffset.y = 170;
            } else {
                quickPanButton.cameraOffset.y = (game.height - 290);
            }
        });
        quickPanButton.scale.setTo(0);
        quickPanButton.visible = false;

        quickPanButton.onClick.add(function() {
            this.map.goToPlayerAvatar();
            this._hideQuickPanButton();
        }, this);
    },

    _showQuickPanButton: function(playerVisibilityState) {
        var quickPanButton = this._quickPanButton;
        if (playerVisibilityState === G.WorldMapPlayerAvatar.VisibilityStates.HiddenBelow) {
            // show below
            if (quickPanButton.direction === G.WorldMapQuickPanButton.Directions.Up) {
                quickPanButton.flipDirection();
            }

            quickPanButton.cameraOffset.x = (game.width * 0.5);
            quickPanButton.cameraOffset.y = (game.height - 290);
            quickPanButton.visible = true;
            game.add.tween(quickPanButton.scale).to({ x: 1, y: 1 }, 250, Phaser.Easing.Sinusoidal.In, true);
        } else if (playerVisibilityState === G.WorldMapPlayerAvatar.VisibilityStates.HiddenAbove) {
            // show above
            if (quickPanButton.direction === G.WorldMapQuickPanButton.Directions.Down) {
                quickPanButton.flipDirection();
            }

            quickPanButton.cameraOffset.x = (game.width * 0.5);
            quickPanButton.cameraOffset.y = 170;
            quickPanButton.visible = true;
            game.add.tween(quickPanButton.scale).to({ x: 1, y: 1 }, 250, Phaser.Easing.Sinusoidal.In, true);
        }
    },

    _hideQuickPanButton: function() {
        var quickPanButton = this._quickPanButton;
        game.add.tween(quickPanButton.scale).to({ x: 0, y: 0 }, 250, Phaser.Easing.Sinusoidal.Out, true)
            .onComplete.add(function() { quickPanButton.visible = false; });
    },

    render: function() {
        Phaser.State.prototype.render.apply(this, arguments);
        return;
        game.debug.text(this.map.y - game.height, 10, 50, '#ff0000');
        game.debug.text(game.load.isLoading, 10, 30);
        game.debug.text(game.load.progressFloat, 10, 60);
    },

    // reward from highscore coin button clicked
    _rewardCoins: function _rewardCoins(amount, options, targetUserId) {
        var worldState = this;
        DDNA.transactionHelper.trackRewards([G.gift.GiftContentType.Coins, amount], [], {
            transactionType: 'REWARD',
            tActionType: 'SOCIAL',
            tGameArea: 'BOTTOM_SCREEN'
        });

        worldState.uiTargetParticles.createCoinBatch(
            game.world.bounds.x + options.animateFrom.x,
            options.animateFrom.y,
            worldState.panel.coinsTxt,
            amount,
        );

        DDNA.socialTracker.incrementParam('numCoinSends', 1);
        DDNA.socialTracker.incrementParam('numFriendsSentCoins', 1);
        DDNA.tracking.socialActionEvent('SEND_COIN', 'COINS', targetUserId, '');
        OMT.platformTracking.logEvent(OMT.platformTracking.Events.LBCoinsGathered, amount, {
            amount,
        });
    },

    _check_GBMessages: async function() {
        await OMT.messaging.loadMessages();
    },

    _check_friendshipChest: async function() {

        if (!OMT.feature.getFeatureFriendshipChest(false)) { return; }
        /**
         * If the chest is unlocked at level and activated.
         * It'll takes appearance-amount of levels to open the promo
         * If the user is new, it should open as soon as they unlock
         */

        if (OMT.feature.getFeatureFriendshipChestActiveByLevel(false)) {
            if (G.saveState.friendshipChestDataManager.getInvitedData() && !G.saveState.friendshipChestDataManager.getPromoInitial()) {
                G.sb('pushWindow').dispatch('friendshipChestFTUAward');
                return;
            }
            if (OMT.feature.getFeatureFriendshipChest()) { // Check again but check iOS
                if (G.saveState.friendshipChestDataManager.getNumberOfLevelsToAppear() <= 0) { // eslint-disable-line no-else-return
                    const assetStatus = OMT.feature.getFriendshipChestAssetStatus();
                    if (G.saveState.friendshipChestDataManager.getCardCount() === 1) {
                        if (assetStatus.highPrio) {
                            G.sb('pushWindow').dispatch('friendshipChestPromo');
                        } else {
                            G.saveState.friendshipChestDataManager.setNumberOfLevelsToAppear(1);
                        }
                    } else if (assetStatus.complete) {
                        G.sb('pushWindow').dispatch('friendshipChestPromo');
                    } else {
                        G.saveState.friendshipChestDataManager.setNumberOfLevelsToAppear(1);
                    }
                }
            }
            G.sb('FriendshipChestCheck').dispatch();
        }
    },

    _organizeWorldSideButtons: async function() {
        // Check async event flags here
        const eventPostCardEvent = false; //await OMT.feature.getEventPostcardFeature();
        /**
         * This is the data object that holds the info about the icons on the world map
         * It sorts it by left and right.
         * The largestWidth is to calculate the middle alignment of all elements in that side
         * so it doesn't look out of place.
         */
        this.UI_button = {
            left: {
                direction: 'left',
                elements: [],
                largestWidth: 0,
            },
            right: {
                direction: 'right',
                elements: [],
                largestWidth: 0,
            },
        };
        if (G.OMTsettings.elements.worldMapButtonOrder) { // The button order is different per game
            const buttonSwitch = (target, isRight) => { // Function that adds the elements into this.UI_button
                console.log(target);
                switch (target.toLowerCase()) {
                    case 'mapgift':
                        if (OMT.feature.getFeature3hGift()) {
                            const hourGift = new G.MapGift();
                            this._iconGroup.addChild(hourGift);
                            this.addUIButtonToSide(isRight, hourGift, G.OMTsettings.elements.mapGift.width, G.OMTsettings.elements.mapGift.height);
                        }
                        break;
                    case 'dailychallenge':
                        const dailyChallenge = new G.UI_DailyChallengeIcon();
                        if (dailyChallenge.visible || dailyChallenge.icon.adIcon.visible) { // If the daily challenge is visible
                            this._iconGroup.addChild(dailyChallenge);
                            this.addUIButtonToSide(isRight, dailyChallenge, G.OMTsettings.elements.dailyChallengeIcon.width, G.OMTsettings.elements.dailyChallengeIcon.height);
                        }
                        break;
                    case 'dailyicon':
                        this.dailySpinIcon = new G.UI_DailyIcon();
                        this._iconGroup.addChild(this.dailySpinIcon);
                        this.addUIButtonToSide(isRight, this.dailySpinIcon, G.OMTsettings.elements.dailyIcon.width, G.OMTsettings.elements.dailyIcon.height);
                        break;
                    case 'friendshipchest':
                        if (OMT.feature.getFeatureFriendshipChest()) {
                            const assetStatus = OMT.feature.getFriendshipChestAssetStatus();
                            const friendshipChest = new UI_FriendshipChest();
                            this._iconGroup.addChild(friendshipChest);
                            if (!assetStatus.highPrio) {
                                friendshipChest.visible = false;
                                friendshipChest.scale.set(0.1);
                                console.log('[ASSET] Preloading high priority friendship chest assets');
                                Friendship_Chest.loadHighPrio(() => { // Background loading happens here too
                                    if (game.state.current !== 'World') return;
                                    friendshipChest.visible = true;
                                    game.add.tween(friendshipChest.scale).to({ x: 1, y: 1 }, 250, Phaser.Easing.Sinusoidal.InOut, true);
                                });
                            }
                            this.addUIButtonToSide(isRight, friendshipChest, G.OMTsettings.friendshipChest.width, G.OMTsettings.friendshipChest.height);
                        }
                        break;
                    case 'xpromo': // init cross promo icon in the UI. Content will get initialized later.
                        // if (OMT.crossPromo.isPlacementActive(XPROMO_PLACEMENTS.ICON_PICTURE_COMBO)) {
                        const xpromoButton = new OMT_UI_CrossPromoMapButton(isRight);
                        this.xpromoButton = xpromoButton;
                        this._iconGroup.addChild(this.xpromoButton);
                        this.addUIButtonToSide(isRight, xpromoButton, G.OMTsettings.crossPromo.worldMapIcon.width, G.OMTsettings.crossPromo.worldMapIcon.height);
                        // }
                        break;
                    case 'eventpostcard':
                        if (eventPostCardEvent) {
                            const postCard = new UI_EventPostcard();
                            this._iconGroup.addChild(postCard);
                            this.addUIButtonToSide(isRight, postCard, G.OMTsettings.postcardEvent.worldMapIcon.width, G.OMTsettings.postcardEvent.worldMapIcon.height);
                        }
                        break;
                }
            };
            for (let i = 0; i < G.OMTsettings.elements.worldMapButtonOrder.left.length; i++) { // Checks it from OMT settings
                buttonSwitch(G.OMTsettings.elements.worldMapButtonOrder.left[i], false);
            }
            for (let i = 0; i < G.OMTsettings.elements.worldMapButtonOrder.right.length; i++) {
                buttonSwitch(G.OMTsettings.elements.worldMapButtonOrder.right[i], true);
            }

            const { alignXDynamically } = G.OMTsettings.elements.worldMapButtonOrder; // Align X dynamically?
            const buttonPositionResize = () => {
                const uiArr = [this.UI_button.left, this.UI_button.right]; // Shoved into a temp array because for ease
                for (let i = 0; i < uiArr.length; i++) {
                    const UI_data = uiArr[i];
                    const isRight = UI_data.direction === 'right';
                    let nextY = isRight ? 125 : 300;
                    for (let j = 0; j < UI_data.elements.length; j++) {
                        const pack = UI_data.elements[j];
                        if (alignXDynamically) { // If its not aligning X dynamically, the elements are using X from their own resize call
                            if (!isRight) {
                                pack.button.x = game.world.bounds.x + UI_data.largestWidth / 2;
                            } else {
                                pack.button.x = game.world.bounds.x + game.width - UI_data.largestWidth / 2;
                            }
                        }
                        pack.button.y = nextY + pack.height / 4;
                        nextY += pack.height * 1.25;
                    }
                }
            };
            G.Utils.cleanUpOnDestroy(this.map, G.sb('onScreenResize').add(buttonPositionResize));
            buttonPositionResize();
        }
    },

    addUIButtonToSide: function(isRight, button, givenWidth, givenHeight) {
        let pack = {
            button: button,
            width: givenWidth || 100,
            height: givenHeight || 100
        }
        let UI_pack;
        if (isRight) {
            UI_pack = this.UI_button.right;
        } else {
            UI_pack = this.UI_button.left;
        }

        UI_pack.elements.push(pack);
        if (UI_pack.largestWidth < pack.width) {
            UI_pack.largestWidth = pack.width;
        }
    },

    /**
     * Check for IE.
     * If you are playing IE, you get a special generic window that tells you:
     * You can't play anymore
     * And switch to a modern browser
     * Heres your player ID if you need help
     */
    checkIE11() {
        const isIE11 = OMT.systemInfo.browserIsIE;
        // eslint-disable-next-line max-len
        const txt = OMT.language.getText('Unfortunately, we are ending support for Internet Explorer 11. To play, please continue on a modern browser. For support on switching browsers, please contact: support@softgames.de');
        if (isIE11) {
            const img = G.makeImage(0, 0, 'sad_gingy_heart_small', [0.5, 0], null);
            const config = {
                windowStyle: GENERIC_WINDOW_STYLE.TEMPLATE,
                template: {
                    text: {
                        text: `${txt}\n\nPlayer ID`,
                        textStyle: 'font-purple',
                        boundaries: {},
                        offset: { y: 5 },
                    },
                    image: {
                        image: img,
                    },
                },
            };
            G.sb('pushWindow').dispatch(['Generic', config]);
        }

        return isIE11;
    },
};